import { Link } from "react-router-dom";

export default function Resources() {
  return (
    <>
      <header className="relative w-full border-b border-b-black bg-gray-200 py-2">
        <section className="mx-auto max-w-[85rem]">
          <h2 className="text-center font-serif text-[110%] font-bold italic md:text-xl">
            Emergency Vehicle Technician Certification Commission
          </h2>
        </section>
      </header>
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              Links &amp; Downloads
            </h1>
            <p className="my-2">
              This page lists EVTCC forms and files available for download, plus
              links to external resources.
            </p>
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Downloads
            </h2>
            <ul className="ml-8 list-disc">
              <li>
                <a
                  href="/downloads/EVTCC-Program-Booklet.pdf"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  EVTCC Program Booklet
                </a>
              </li>
              <li>
                <a
                  href="https://register.evtcc.org"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Online Registration
                </a>
              </li>
              <li>
                <a
                  className="my-2 text-(--themered) hover:text-(--darkred) hover:underline"
                  href="/downloads/EVTCC-Test-Site-List.pdf"
                >
                  Download a list of testing events
                </a>
              </li>
              <li>
                <a
                  href="/downloads/EVTCC-Exam-Registration.pdf"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Exam Registration Form
                </a>
              </li>
              <li>
                <a
                  href="/downloads/EVTCC-Level-Application.pdf"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  EVTCC Level Application
                </a>
              </li>
              <li>
                <a
                  href="/downloads/EVTCC-Patch-Order-Form.pdf"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  EVTCC Patch Order Form
                </a>
              </li>
            </ul>
          </section>
          <section className="mt-2">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Training
            </h2>
            <p className="my-2">
              It is imperative to use the learning objectives that can be found
              on the{" "}
              <Link
                to="/exams"
                className="text-(--themered) hover:text-(--darkred) hover:underline"
              >
                Exams &amp; Prep
              </Link>{" "}
              page whether or not you take a class. If you wish to attend
              training, we recommend reviewing the learning objectives
              beforehand so that you will be prepared to leverage training and
              know what you need to ask the instructor about.
            </p>
          </section>
          <section className="mt-2">
            <h3 className="my-2 ml-2 font-serif text-xl font-bold italic">
              EVTCC-oriented EVT training
            </h3>
            <p className="my-2 ml-2">
              These training providers are not formally affiliated with EVTCC.
              They offer EVT training that is specifically created, at least in
              part, to prepare technicians for EVTCC tests.
            </p>
            <ul className="ml-8 list-disc">
              <li>
                <a
                  href="https://azfiremechanics.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  AZ Fire Mechanics
                </a>{" "}
                (incl. Quarterly Mechanics&#8217; Seminars)
              </li>
              <li>
                <a
                  href="https://coevta.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Colorado Fire Mechanics Association
                </a>{" "}
                (annual Mechanics&#8217; Seminars in July/August)
              </li>
              <li>
                <a
                  href="http://www.evttraining.net/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Emergency Vehicle Technical Support
                </a>{" "}
                (Ocala, FL, plus{" "}
                <a
                  href="https://evttraining.net/virtual-learning/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  live virtual learning
                </a>
                )
              </li>
              <li>
                <a
                  href="https://evttps.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  EVT Test Preparation Services
                </a>{" "}
                (based in Pennsylvania, training brought to you)
              </li>
              <li>
                <a
                  href="https://firepumptraining.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fire Pump Training LLC
                </a>{" "}
                (F3 & F7)
              </li>
              <li>
                <a
                  href="https://www.fdsoa.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fire Department Safety Officers Association
                </a>{" "}
                (Annual Maintenance Symposium; they bring training to you)
              </li>
              <li>
                <a
                  href="https://www.ffca.org/evt"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Florida Fire Chiefs&#8217; Association
                </a>{" "}
                (Florida-wide)
              </li>
              <li>
                <a
                  href="https://www.fvtc.edu/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fox Valley Technical College
                </a>{" "}
                (Appleton, WI)
              </li>
              <li>
                <a
                  href="https://www.greenwoodev.com/training/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Greenwood Emergency Vehicles
                </a>{" "}
                (MA)
              </li>
              <li>
                <a
                  href="https://www.heatevt.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Heartland Emergency Apparatus Technicians Association
                </a>
              </li>
              <li>
                <a
                  href="https://www.ifama.net/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Illinois Fire Apparatus Mechanics Association
                </a>
              </li>
              <li>
                <a
                  href="http://www.newenglandfirechiefs.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  New England Association of Fire Chiefs
                </a>
              </li>
              <li>
                <a
                  href="https://oaevt.org/training-symposium/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Ohio Association of Emergency Vehicle Technicians
                </a>{" "}
                (Ohio Fire Academy, Reynoldsburg, OH)
              </li>
              <li>
                <a
                  href="http://www.okevt.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Oklahoma Association of Emergency Vehicle Technicians
                </a>{" "}
                (Edmond, OK)
              </li>
              <li>
                <a
                  href="https://www.ofaema.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Oregon Fire Apparatus Equipment Mechanics Association
                </a>
              </li>
              <li>
                <a
                  href="http://www.spartaner.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Spartan Emergency Response
                </a>
              </li>
              <li>
                <a
                  href="https://www.sutphen.com/training/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Sutphen
                </a>
              </li>
              <li>
                <a
                  href="https://teex.org/class/ASP150/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Texas A&amp;M Extension Service
                </a>{" "}
                (College Station, Texas)
              </li>
              <li>
                <a
                  href="https://taevt.org/swevt-training-conference/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Texas Association of EVTs
                </a>{" "}
                (training in Fort Worth, TX)
              </li>
              <li>
                <a
                  href="https://www.washingtonfirechiefs.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Washington Fire Chiefs Association
                </a>
              </li>
              <li>
                <a
                  href="https://www.waevt.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Wisconsin Association of Emergency Vehicle Technicians
                </a>{" "}
                (Appleton, WI)
              </li>
            </ul>
          </section>
          <section className="mt-2">
            <h3 className="my-2 ml-2 font-serif text-xl font-bold italic">
              General EVT training
            </h3>
            <p className="my-2 ml-2">
              These training providers are not formally affiliated with EVTCC.
              They offer EVT training that may be helpful for EVTCC tests, but
              is not specifically oriented to EVTCC&#8217;s tests or
              certifications.
            </p>
            <ul className="ml-8 list-disc">
              <li>
                <a
                  href="https://cafiremech.com/fall-spring-academy/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  California Fire Mechanics Academy
                </a>
              </li>
              <li>
                <a
                  href="http://www.cfema.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Connecticut Fire Equipment Mechanics Association
                </a>
              </li>
            </ul>
          </section>
          <section className="mt-2">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Others in the Industry
            </h2>
            <p className="my-2">
              As with training providers listed on this page, none of the
              organizations listed here are formally affiliated with EVTCC. We
              provide these links because they may be of interest to you.
            </p>
          </section>
          <section className="ml-2 mt-2">
            <h3 className="my-2 font-serif text-xl font-bold italic">
              Manufacturers
            </h3>
            <ul className="ml-8 list-disc">
              <li>
                <a
                  href="https://www.darley.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Darley
                </a>
              </li>
              <li>
                <a
                  href="https://e-one.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  E-One
                </a>{" "}
                (Ocala, FL)
              </li>
              <li>
                <a
                  href="https://www.haleproducts.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Hale Products
                </a>
              </li>
              <li>
                <a
                  href="https://www.piercemfg.com/fire-trucks/products-overview/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Pierce
                </a>
              </li>
              <li>
                <a
                  href="https://rosenbaueramerica.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Rosenbauer
                </a>
              </li>
              <li>
                <a
                  href="https://www.waterousco.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Waterous Co.
                </a>
              </li>
            </ul>
          </section>
          <section className="ml-2 mt-2">
            <h3 className="my-2 font-serif text-xl font-bold italic">
              Industry Advocates, Associations, Etc.
            </h3>
            <ul className="ml-8 list-disc">
              <li>
                <a
                  href="https://www.fdic.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  FDIC International
                </a>
              </li>
              <li>
                <a
                  href="https://www.firerescue1.com/fire-chief"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fire Chief Magazine
                </a>
              </li>
              <li>
                <a
                  href="https://www.firefusionconference.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fire Fusion
                </a>{" "}
                (formerly Firehouse Expo; Charleston, SC)
              </li>
              <li>
                <a
                  href="https://www.iafc.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  International Association of Fire Chiefs
                </a>
              </li>
              <li>
                <a
                  href="https://www.lievt.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Long Island Association of EVTs
                </a>
              </li>
              <li>
                <a
                  href="https://www.ase.com/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  National Institute for Automotive Service Excellence
                </a>
              </li>
              <li>
                <a
                  href="https://www.nfpa.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  National Fire Protection Association
                </a>{" "}
                (NFPA)
              </li>
              <li>
                <a
                  href="https://www.sgfma.org/"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Southeast Governmental Fleet Managers Association
                </a>
              </li>
            </ul>
          </section>
        </div>
      </main>
    </>
  );
}
